import {useState, useMemo} from 'react'
import {useQueries} from 'react-query'
import {Get} from '../../../../setup'
import {LoadingState, PeriodType} from '../../../../global'
import {initialReportState, ReportAdministration, ReportContextInterface, ReportStatistics} from '../../../@types'

const REPORT_STATISTICS = process.env.REACT_APP_REPORT_DATA || '/v2/data-rapport'

const REPORT_ADMINISTRATION = process.env.REACT_APP_REPORT_ADMINISTRATION || 'administration-de-rapport'

type Props = {
    period: PeriodType
}

export const useReportData = ({period}: Props) => {

    const [loading, setLoading] = useState<LoadingState>('pending')
    const [data, setData] = useState<ReportContextInterface>(initialReportState)

    const queries = useQueries([
        {
            queryKey: ['REPORT_STATISTICS', period],
            queryFn: () => Get<ReportStatistics>({endpoint: REPORT_STATISTICS, period}),
            enabled: !!period,
            onSuccess: (statistics: ReportStatistics) => {
                setData((prevState: ReportContextInterface) => ({
                    ...prevState,
                    statistics: {
                        ...prevState.statistics,
                        ...statistics,
                        totalUpdate: {
                            ...prevState.statistics.totalUpdate,
                            ...statistics.totalUpdate,
                            wp: statistics.totalUpdate.wp.flat(),
                            theme: statistics.totalUpdate.theme.flat(),
                            plugin: statistics.totalUpdate.plugin.flat(),
                        },
                    },
                    loadingStatus: 'fulfilled',
                    period,
                }))
                setLoading('fulfilled')
            },
            onError: (error: any) => {
                console.error('Failed to fetch Statistics data:', error)
                setLoading('rejected')
            },
        },
        {
            queryKey: ['REPORT_ADMINISTRATION', period],
            queryFn: () => Get<ReportAdministration>({endpoint: REPORT_ADMINISTRATION, period}),
            enabled: !!period,
            onSuccess: (administration: ReportAdministration) => {
                setData((prevState: ReportContextInterface) => ({
                    ...prevState,
                    administration,
                }))
            },
            onError: (error: any) => {
                console.error('Failed to fetch Administration data:', error)
                setLoading('rejected')
            },
        },
    ])

    const isLoading = queries.some((query) => query.isLoading)
    const contextValue = useMemo(() => data, [data])

    return {
        data: contextValue,
        isLoading,
        loading,
    }
}